module.exports = __webpack_public_path__ + "img/6c53063.jpg";